import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { MultiselectEvent, MultiselectItem } from '../../multiselect/multiselect.component';
import {
  FilterGroup,
  FilterUIType,
  ODataFilterValues,
} from '../../odata-filter/models/odata-filter';
import { OPERATORS } from '../../odata-filter/models/operators';
import { SearchValueType } from '../../odata-filter/models/search-value-type';
import { SelectedFilter } from '../../odata-filter/models/selected-filter';

@Component({
  selector: 'quick-odata-filter-item',
  templateUrl: './quick-odata-filter-item.component.html',
  styleUrls: ['./quick-odata-filter-item.component.scss'],
})
export class QuickODataFilterItemComponent {
  @Input() filterItem: QuickFilterItem;
  @Output() addFilter = new EventEmitter<QuickFilterItem>();
  @Output() removeFilter = new EventEmitter<QuickFilterItem>();
  multiselectItems: MultiselectItem[] = [];

  get operators() {
    return OPERATORS[this.filterItem.filter.valueType].operators;
  }

  get inputType() {
    if (this.filterItem.filter.valueType == SearchValueType.Number) return 'number';
    if (
      this.filterItem.filter.valueType == SearchValueType.Date ||
      this.filterItem.filter.valueType == SearchValueType.DateRange
    )
      return 'date';

    return 'text';
  }

  get uiType() {
    return FilterUIType;
  }
  get selectedMultiselectItems(): MultiselectItem[] {
    return this.filterItem.searchValues.map((v) => new MultiselectItem(v.searchValue, v.name));
  }

  multiselectSelectionChanged(event: MultiselectEvent) {
    this.filterItem.searchValues = event.selectedItems.map(
      (x) => new ODataFilterValues(x.id, x.name)
    );
    this.filterChanged();
  }

  checkboxChanged() {
    this.filterItem.filterOperator = this.operators[0];
    this.filterItem.isFilterApplied = false;
    this.resetSelectedFilterSearchValues();
    this.setMultiselectItems();
    if (!this.filterItem.isSelected) {
      this.removeFilter.emit(new QuickFilterItem(this.filterItem));
    }
  }

  filterChanged() {
    this.filterItem.isFilterApplied = false;
    if (this.filterItem.filterOperator) {
      if (this.filterItem.filterOperator.isSearchValueNeeded) {
        if (
          (this.filterItem.uiType == FilterUIType.Multiselect &&
            this.filterItem.searchValues.length) ||
          (this.filterItem.uiType != FilterUIType.Multiselect && this.filterItem.searchValue != '')
        ) {
          this.filterItem.isFilterApplied = true;
          this.addFilter.emit(new QuickFilterItem(this.filterItem));
        }
      } else {
        this.filterItem.isFilterApplied = true;
        this.addFilter.emit(new QuickFilterItem(this.filterItem));
      }
    }
  }

  resetSelectedFilterSearchValues() {
    this.filterItem.searchValue = '';
    this.filterItem.searchValues = [];
  }

  setMultiselectItems() {
    const values =
      this.filterItem.filterOperator.defaultSearchValues ?? this.filterItem.filter.values;
    this.multiselectItems = values?.map((v) => new MultiselectItem(v.searchValue, v.name));
  }
}

export class QuickFilterItem extends SelectedFilter {
  constructor(data: any) {
    super(data);
    if (data != null) {
      this.group = data.group;
    }
  }
  public isSelected: boolean = false;
  public rank: number;
  public group: FilterGroup;
}
